import { Card, Spinner } from 'react-bootstrap';
import { Line } from 'react-chartjs-2';

import { Chart } from '../components/vendor/Chart';
import { currencyFormatter } from '../helpers/currencyFormatter';
import { formatDateLabel } from '../helpers/dateRange';
import { RevenueTrendResponse } from '../types/dashboard';

const CHART_BODY_MIN_HEIGHT = 300;

interface AnalyticsSalesProps {
  data?: RevenueTrendResponse;
  isLoading?: boolean;
}

export default function AnalyticsSales({ data, isLoading }: AnalyticsSalesProps) {
  const trend = data?.trend ?? [];
  const hasData = !isLoading && trend.length > 0;

  const labels = trend.map(point => formatDateLabel(point.date));

  const datasets = [
    {
      data: trend.map(point => point.amount)
    }
  ];

  const options = {
    scales: {
      y: {
        ticks: {
          callback: function (value: any) {
            return currencyFormatter(value);
          }
        }
      }
    }
  };

  return (
    <Card className="h-100">
      <Card.Header>
        <h4 className="card-header-title">Revenue Trend</h4>
      </Card.Header>
      <Card.Body
        style={{ minHeight: CHART_BODY_MIN_HEIGHT }}
        className="d-flex align-items-center justify-content-center"
      >
        {isLoading ? (
          <Spinner animation="border" />
        ) : hasData ? (
          <div className="w-100">
            <Chart>
              <Line data={{ labels, datasets }} options={options} />
            </Chart>
          </div>
        ) : (
          <p className="text-muted text-center mb-0">No data available</p>
        )}
      </Card.Body>
    </Card>
  );
}
